import { format } from 'owa-localize';
import { TxpGriffinSettingsPayload } from 'owa-calendar-configuration';
import { makePostRequest } from 'owa-ows-gateway/lib/makeServiceRequest';
import { getGuid } from 'owa-guid';
import { GRIFFIN_REQUEST_BASEURL, USER_SETTINGS } from '../helpers/TxpConstants';

import { logCalendarUsage } from 'owa-shared-analytics';
import TxpSettingsEntryPoint from '../store/schema/TxpSettingsEntryPoint';

export default function postUserSettingsAction(
    body: TxpGriffinSettingsPayload,
    entryPoint: TxpSettingsEntryPoint
): Promise<any> {
    logCalendarUsage('TxpSettingsSave', getTxpSettingsSaveCustomData(body, entryPoint));

    return makePostRequest(
        format(GRIFFIN_REQUEST_BASEURL, USER_SETTINGS),
        body,
        getGuid(),
        true /*returnFullResponse*/,
        null /*customHeaders*/,
        null /*throwServiceError*/,
        true /*sendPayloadAsBody*/
    );
}

function getTxpSettingsSaveCustomData(
    body: TxpGriffinSettingsPayload,
    entryPoint: TxpSettingsEntryPoint
) {
    return {
        ...body.EntityTypeProcessorLevelSettings,
        entryPoint: entryPoint,
        createEventsAsPrivate: body.CreateEventsFromEmailAsPrivate,
    };
}
